import { render, staticRenderFns } from "./EnacProcedureAtpDafEditApprovalForm.vue?vue&type=template&id=5cbc3c31"
import script from "./EnacProcedureAtpDafEditApprovalForm.vue?vue&type=script&lang=js"
export * from "./EnacProcedureAtpDafEditApprovalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports